import { Component, input, output, signal, computed, effect, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from '../../default/login/service/login-service/auth.service';
import { PermissionService } from '../../../services/permission.service';
import { ConfigService } from '../../../services/config.service';
import { MenuItem } from '../../../models/permission.model';
import { ScrollbarComponent } from '../../ui/scrollbar/scrollbar.component';
import { TooltipComponent } from '../../ui/tooltip/tooltip.component';

@Component({
  selector: 'app-sidebar',
  imports: [RouterLink, RouterLinkActive, ScrollbarComponent, TooltipComponent],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.css'
})
export class SidebarComponent {
  isOpen = input<boolean>(true);
  toggleSidebar = output<void>();

  private configService = inject(ConfigService, { optional: true });
  themeUpdateTrigger = signal(0);

  menuItems = computed<MenuItem[]>(() => {
    return this.permissionService.getFilteredMenuItems();
  });

  constructor(
    public authService: AuthService,
    private permissionService: PermissionService
  ) {
    // Watch for theme changes
    if (this.configService) {
      effect(() => {
        this.configService?.mode();
        this.configService?.config();
        this.themeUpdateTrigger.update(v => v + 1);
      });
    }
  }

  onToggle(): void {
    this.toggleSidebar.emit();
  }

  onLogout(): void {
    this.authService.logout();
  }
}

